import { createSlice } from '@reduxjs/toolkit';
import { ITableFiltersParams } from 'core/models/general.models';
import { IBookingDataItem } from '@dashboardWireline/WirelineDepartments/WIrelineDepartament.models';

export interface IState {
  count: number
  isLoading: boolean
  error: object | null
  params: ITableFiltersParams
  results: IBookingDataItem[]
}

const initialState: IState = {
  count: 0,
  results: [],
  error: null,
  params: {},
  isLoading: true,
};

const BookingSellerDataSlice = createSlice({
  name: 'getBookingSellerData',
  initialState,
  reducers: {
    getBookingSellerDataRequest: (state, action) => ({
      ...state,
      isLoading: true,
      params: action.payload,
    }),
    getBookingSellerDataSuccess: (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
    }),
    getBookingSellerDataFailure: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
      results: [],
    }),
    clearBookingSellerDataAction: () => initialState,
  },
});

export const {
  getBookingSellerDataRequest,
  getBookingSellerDataSuccess,
  getBookingSellerDataFailure,
  clearBookingSellerDataAction,
} = BookingSellerDataSlice.actions;

export const getBookingSellerDataReducer = BookingSellerDataSlice.reducer;
